export interface Rubrique {
    id: number;
    name: string;
    sortOrder: number;
}

export type RubriqueType = 'article' | 'faq' | 'decrypt' | 'tuto'; // TODO : plus tard : 'article' => 'actualite'

export const toRubriqueForm = (rubrique: Rubrique, type: RubriqueType): RubriqueForm => ({
    ...rubrique,
    type,
    order: rubrique.sortOrder,
});

export interface RubriqueForm {
    name: string;
    order: number;
    type: RubriqueType;
}
